// Copied to https://github.com/DietLabs/byAnn-landings/blob/master/src/SaleProduct/SaleProductContext.js

export const FIRST = 'first';
export const LAST = 'last';
